import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postInventoryPhase1 } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.POST.P1,
  api: postInventoryPhase1,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/inventories/PostPhase1Action.js